function canonicalSubscriptionPlanSlug(slug) {
  if (!slug) return null;
  return slug === 'app_light' ? 'starter' : slug;
}

function resolveCurrentSubscriptionPlanTitle(params = {}) {
  const labels = params.labels || {};
  const plan = params.plan || (params.subscription && params.subscription.plan) || null;
  const slug = plan && plan.slug ? canonicalSubscriptionPlanSlug(plan.slug) : null;
  const serverName = typeof (plan && plan.name) === 'string' ? plan.name.trim() : '';

  if (slug && Object.prototype.hasOwnProperty.call(labels, slug)) {
    return labels[slug];
  }
  if (serverName) {
    return serverName;
  }
  return null;
}

function isCurrentSubscriptionPaid(params = {}) {
  const subscription = params.subscription || null;
  if (subscription && subscription.plan) {
    return !subscription.is_free && canonicalSubscriptionPlanSlug(subscription.plan.slug) !== 'free';
  }
  return false;
}

module.exports = {
  canonicalSubscriptionPlanSlug,
  resolveCurrentSubscriptionPlanTitle,
  isCurrentSubscriptionPaid,
};
